// src/components/AddCompanyForm/ContactCard.jsx
import React from "react";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  InputAdornment,
  Typography,
} from "@mui/material";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import { useTranslation } from "react-i18next";

export default function ContactCard({ form, setForm }) {
  const { t } = useTranslation("settings");
  const set = (patch) => setForm((p) => ({ ...p, ...patch }));

  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardHeader
        title={t("addCompanyForm.contact.title")}
        subheader={t("addCompanyForm.contact.subheader")}
      />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label={t("addCompanyForm.contact.emailLabel")}
              value={form.email}
              onChange={(e) => set({ email: e.target.value })}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label={t("addCompanyForm.contact.phoneLabel")}
              value={form.telefone}
              onChange={(e) => set({ telefone: e.target.value })}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={t("addCompanyForm.contact.phoneExtraLabel")}
              value={form.telefone_adicional}
              onChange={(e) => set({ telefone_adicional: e.target.value })}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                pt: 0.5,
                pb: 0.5,
                borderTop: 1,
                borderColor: "divider",
              }}
            >
              <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                {t("addCompanyForm.contact.supportSection")}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={7}>
            <TextField
              label={t("addCompanyForm.contact.supportEmailLabel")}
              value={form.support_email}
              onChange={(e) => set({ support_email: e.target.value })}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              label={t("addCompanyForm.contact.supportWhatsAppLabel")}
              value={form.support_whatsapp}
              onChange={(e) => set({ support_whatsapp: e.target.value })}
              fullWidth
              placeholder="5511987654321"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <WhatsAppIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: -1 }}>
              {t("addCompanyForm.contact.supportWhatsAppHelper")}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label={t("addCompanyForm.contact.hoursLabel")}
              value={form.atendimento_horario}
              onChange={(e) => set({ atendimento_horario: e.target.value })}
              fullWidth
              placeholder={t("addCompanyForm.contact.hoursPlaceholder")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccessTimeRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
